import { useLocation, useNavigate } from "react-router";
import Container from "../components/common/Container";
import PageHeader from "../components/common/PageHeader";
import WorkShiftTable from "../components/WorkShift/Table";
import PlusIcon from "../components/common/Icons/PlusIcon";

const WorkShiftSettings = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Container>
      <PageHeader
        pageTitle="Vardiya Listesi"
        isButtoned
        buttonIcon={<PlusIcon />}
        buttonText="Yeni Vardiya"
        buttonOnClick={() => {
          navigate(`${location.pathname}/new`);
        }}
      />
      <WorkShiftTable />
    </Container>
  );
};

export default WorkShiftSettings;
